<template>
  <div>
    <vx-card class="mt-base mb-5" :title="activityTitle">
      <p class="mb-5">
        A big part of studying medicine is learning all of the names, locations and functions of the
        different parts of the body.
      </p>
      <p class="mb-5">
        For this exercise, you will find out the answers to the below clues. The two hints are that
        the left column tells you the first letter of the body part, and the rightmost column gives
        you more context and information.
      </p>
      <p class="mb-5">
        If you feel very confident, you can try the online, timed version of the activity here:
      </p>
      <p class="mb-5">
        <a href="https://www.sporcle.com/games/sammyjay/humanbodyparts?t=anatomy" target="_blank"
          >https://www.sporcle.com/games/sammyjay/humanbodyparts?t=anatomy</a
        >
      </p>
      <p class="mb-5">No cheating!</p>

      <table class="table default-table">
        <tr class="header">
          <th width="10%" class="text-center">Letter</th>
          <th width="50%" class="text-center">Body Part</th>
          <th width="40%" class="text-center">Hint</th>
        </tr>
        <tr class="body" v-for="(question, letter, index) in questions" :key="index">
          <td class="text-center">{{ letter }}</td>
          <td><text-block v-model="data['question' + index]" :editable="isEditable" /></td>
          <td class="text-center">{{ question }}</td>
        </tr>
      </table>
      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      questions: {
        A: 'Great Vessel of the Heart',
        B: 'Part of the CNS',
        C: 'Inferior Part of Vertebral Column',
        D: 'Major Muscle of Respiration',
        E: 'Covers Trachea Whilst Swallowing',
        F: 'Longest Bone in the Body',
        G: 'Stores bile produced in the liver.',
        H: 'Main Organ of the Circulatory System',
        I: 'One of the Three Small Bones in the Ear',
        J: 'Part of the Small Intestine',
        K: 'Pair of Organs Involved in Urine Production',
        L: 'Respiratory Organs',
        M: 'Protective Covering of CNS',
        N: 'Upper Part of the Pharynx',
        O: 'Small glands located on either side of the uterus that produce eggs and hormones',
        P: "'Major' Muscle of the Chest",
        Q: 'Group of Muscles on the Thigh',
        R: 'Part of the Eye',
        S: 'Organ Involved in Blood Purification in Upper Left Abdomen',
        T: 'Male organ responsible for making testosterone',
        U: 'Tube Which Carries Urine Away From Bladder',
        V: 'Great Vessel; has Inferior and Superior Portions',
        W: 'The third and final set of molars that most people get in their late teens or early twenties',
        X: 'Part of the Sternum (breastbone)',
        Y: 'Constituent of Bone Within Medullary Cavity, Stores Fats',
        Z: 'Bones of the Face, Commonly known as Cheekbones',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
};
</script>
